import * as dayjs from 'dayjs';
import { HostInterface } from '@splixer/common';
import { uNumber, Uuid } from '@hidat/huijs-common';
import { PlayerExtendedBranding } from './extended-branding.model';
import { Expose, Transform, Type } from 'class-transformer';
import { dayjsTransformer } from '@hidat/huijs-dates';

/**
 * Host/DJ, without any includes.
 * This helps us avoid circular references
 */
export class PlayerHostBase implements HostInterface {
  @Expose({ name: 'id' })
  id: number | undefined = undefined;

  @Expose({ name: 'uid' })
  uid: string | undefined = undefined;

  @Expose({ name: 'name' })
  name: string | undefined = undefined;
  @Expose({ name: 'air_name' })
  airName: string | undefined = undefined;
  @Expose({ name: 'description' })
  description: string | undefined = undefined;
  @Expose({ name: 'tag_line' })
  tagLine: string | undefined = undefined;
  @Expose({ name: 'image_url' })
  imageUrl: string | undefined = undefined;
  @Expose({ name: 'branding' })
  @Type(() => PlayerExtendedBranding)
  branding: PlayerExtendedBranding = {};
  @Expose({ name: 'priority' })
  priority: uNumber = undefined;
  @Expose({ name: 'default_mix_id' })
  defaultMixId: number | undefined = undefined;

  @Expose({ name: 'duration' })
  duration: number | undefined = undefined;
  @Expose({ name: 'invalid_segments' })
  invalidSegments: number | undefined = undefined;
  @Expose({ name: 'station_id' })
  stationId: number | undefined = undefined;
  @Expose({ name: 'status' })
  status: number | undefined = undefined;

  @Expose({ name: 'created_at' })
  @Transform(dayjsTransformer, { toClassOnly: true })
  createdAt: dayjs.Dayjs | undefined = undefined;
  @Expose({ name: 'updated_at' })
  @Transform(dayjsTransformer, { toClassOnly: true })
  updatedAt: dayjs.Dayjs | undefined = undefined;

  // keep compiler happy
  remoteCode: string | undefined;
  remoteId: number | undefined;
  tenantId: Uuid | undefined;
}
